module.exports = __webpack_public_path__ + "img/smiley-aclap.a327b8aa.gif";